export default __webpack_public_path__ + "static/media/icon-play.e8d4e569.svg";